import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CarouselInPreviewVM, CarouselViewerVM } from 'src/app/shared/interfaces/image-viewer.interface';
import { DialogService } from '../../services/dialog.service';
import { LocalizationService } from '../../services/localization.service';
import { FireStorageService } from '../../services/storage.service';
import { ImageCarouselViewerComponent } from '../image-carousel-viewer/image-carousel-viewer.component';

@Component({
  selector: 'app-image-preview-carousel[carouselVM]',
  templateUrl: './image-preview-carousel.component.html',
  styleUrls: ['./image-preview-carousel.component.scss']
})
export class ImagePreviewCarouselComponent {
  @Input() carouselVM!: CarouselInPreviewVM;
  @Output() onRemove = new EventEmitter<number>();

  public loaded = false;
  public isRemoving = false;
  constructor(
    private ls: LocalizationService,
    private storageService: FireStorageService,
    private dialogService: DialogService
  ) {}

  public get isCarousel(): boolean {
    return this.carouselVM.images.length > 1;
  }

  public isDefectDetailsView(layout: 'default' | 'defect-details' | undefined): boolean {
    return layout === 'defect-details';
  }

  public showImage(index: number): void {
    if (!this.isCarousel || this.isRemoving) return;
    this.dialogService.openSimpleDialog<ImageCarouselViewerComponent, CarouselViewerVM>(
      ImageCarouselViewerComponent,
      {
        idx: index,
        layout: this.carouselVM.layout,
        authorName: this.carouselVM?.authorName,
        images: this.carouselVM.images
      },
      {
        width: this.carouselVM.viewerWidth,
        height: this.carouselVM.viewerHeight,
        panelClass: this.carouselVM.viewerPanelClass,
        autoFocus: false
      }
    );
  }

  public removeImage(index: number): void {
    this.isRemoving = true;
    const imageToDelete = { ...this.carouselVM.images[index] };
    this.dialogService
      .openConfirmationDialog({
        text: imageToDelete.fileName
          ? this.ls.trReplace('guard.deleteFileName', { $filename: imageToDelete.fileName })
          : this.ls.translate('guard.deleteFile'),
        acceptKey: 'button.delete',
        cancelKey: 'button.cancel'
      })
      .subscribe((res) => {
        if (res) {
          this.storageService.deleteFile(imageToDelete.path);
          if (imageToDelete.originalPath) this.storageService.deleteFile(imageToDelete.originalPath);
          this.carouselVM.images = this.carouselVM.images.filter((_, i) => i !== index);
          this.onRemove.emit(index);
        }
        this.isRemoving = false;
      });
  }
}
